import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { ListingFormValues } from "@/components/listings/filters/FilterSchema";

export const useFormChanges = (
  form: UseFormReturn<ListingFormValues>,
  formTouched: boolean, // formTouched is now derived, no setter needed here
  validateOnChange: boolean
) => {
  useEffect(() => {
    // This hook's primary purpose (setting formTouched based on touchedFields)
    // is no longer needed as formTouched is now derived from currentStep in useFormState.
    // It can remain if there are other side effects needed when form changes,
    // but for now, it will simply watch the form without modifying formTouched.
    const subscription = form.watch(() => {
      // No action needed here for formTouched as it's derived.
      // This useEffect can be removed if no other side effects are desired on form changes.
    });
    return () => subscription.unsubscribe();
  }, [form]); // Dependencies updated: formTouched and setFormTouched are no longer dependencies
};
